'use client';

import { useCallback } from 'react';
import { getCaptcha, getCaptchaProvider } from '@/lib/captcha';

export function useRecaptcha() {
  const executeCaptcha = useCallback((action: string) => getCaptcha(action), []);
  // Backwards-compatible token-only API for callers still using the legacy name.
  const executeRecaptcha = useCallback(async (action: string): Promise<string | null> => {
    try {
      return (await getCaptcha(action)).token;
    } catch {
      return null;
    }
  }, []);

  return { executeCaptcha, executeRecaptcha, captchaProvider: getCaptchaProvider(), isReady: true };
}
